<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "App",
};
</script>

<style>

@import url("https://fonts.googleapis.com/css?family=Montserrat");


.table-sm td.leftAlign {
  text-align: left !important;
}

.table-striped tbody {
  cursor: pointer;
}



.form-control:focus {
  border-color: #f29406;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.btn {
  background-color: #f29406 !important;
  border-color: #f29406 !important;
  color: white !important;
}
.btn:hover {
  background-color: white !important;
  border-color: #f29406 !important;
  color: #f29406 !important;
}

.modal-header {
  background-color: #f29406;
}
.modal-header .close {
  color: white;
}

.modal-body h3 {
  text-align: left;
  font-weight: bold;
}
.modal-title {
  color: white;
  font-weight: bold;
  font-size: 1.2em;
}

.modal-res {
  font-weight: bold;
}

.line-heading {
  width: 10%;
  height: 3px;
  background-color: #f29406;
  margin: 10px 0 25px 0;
}
.temps_tab {
  color: #f29406;
  font-size: 1.3em;
  font-weight: bold;
}

.header-tab {
  padding: 15px;
  background-color: #e7e7e7;
}

.underline {
  text-decoration: underline !important;
  font-size: 1rem;
}

#top-bar {
  background-color: #14213D;
  padding: 3px;
}

.flex-gap{
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue